import type { AxiosInstance } from 'axios'

export type NpCancelSessionRequest = {
  userLyraId: string
  appointmentId: number
}

export type NpCancelSessionResult = {
  success: boolean
  errorCode: string | null
  message: string | null
  cancelledSessionIds: number[]
  clearedSlotSessionIds: number[]
  calendarRemovedSessionIds: number[]
  errors: string[]
  warnings: string[]
}

/** Uses the platform's authenticated client, whose base URL includes /services. */
export async function cancelNpSession(
  client: Pick<AxiosInstance, 'delete'>,
  { userLyraId, appointmentId }: NpCancelSessionRequest,
): Promise<NpCancelSessionResult> {
  const { data } = await client.delete<NpCancelSessionResult>(`/v1/np/calendar/${userLyraId}/sessions/${appointmentId}`)
  if (!data.success) {
    throw new Error(data.errorCode ?? 'cancellation_failed')
  }
  return data
}
